import React from 'react';
import { Box, Heading, Paragraph } from 'components';

import type { ShipmentQuoteAppT } from 'apps/shipmentQuote/app';
import { clientStore } from 'apps/client/app';
import { formatDate } from 'utils/formatStrings';
import { observer } from 'mobx-react';

type PropsT = {
  quote: ShipmentQuoteAppT;
};

export const DetailsSection = observer(({ quote }: PropsT) => {
  const manufacturer = quote.productQuotes.apps[0].supplier.companyName;
  const manufacturerCountry =
    quote.productQuotes.apps[0].supplier.address?.country;
  const shippingProvider = quote.shippingQuote.provider;
  const { validUntil } = quote;
  const isIntermediatorMode = clientStore.currentPortal === 'INTERMEDIATOR';
  return (
    <Box sx={{ display: 'flex', width: '50%' }}>
      <Box mr={8}>
        {isIntermediatorMode ? (
          <Box mb={4}>
            <Heading level='5' size='small'>
              Manufacturer
            </Heading>
            <Paragraph>{manufacturer}</Paragraph>
          </Box>
        ) : (
          <>
            {manufacturerCountry && (
              <Box mb={4}>
                <Heading level='5' size='small'>
                  Produced in
                </Heading>
                <Paragraph>{manufacturerCountry}</Paragraph>
              </Box>
            )}
          </>
        )}
        <Box mb={4}>
          <Heading level='5' size='small'>
            Shipping Provider
          </Heading>
          <Paragraph>{shippingProvider || '-'}</Paragraph>
        </Box>
        <Box mb={4}>
          <Heading level='5' size='small'>
            Shipping Time
          </Heading>
          <Paragraph>{quote.shippingQuote.deliveryTime} days</Paragraph>
        </Box>
        <Box>
          <Heading level='5' size='small'>
            Incoterm
          </Heading>
          <Paragraph>{quote.incoterm}</Paragraph>
        </Box>
      </Box>
      <Box>
        <Box>
          <Heading level='5' size='small'>
            Valid Until
          </Heading>
          <Paragraph>{validUntil ? formatDate(validUntil) : '-'}</Paragraph>
        </Box>
        {isIntermediatorMode && (
          <Box mt={4}>
            <Heading level='5' size='small'>
              Take Rate
            </Heading>
            <Paragraph>{quote.takeRate}%</Paragraph>
          </Box>
        )}
        {/* {quote.downPayment < 100 && (
          <Box mt={4}>
            <Heading level='5' size='small'>
              Upfront
            </Heading>
            <Paragraph>{quote.downPayment}%</Paragraph>
          </Box>
        )} */}
        <Box mt={4}>
          <Heading level='5' size='small'>
            Manufacturing Time
          </Heading>
          <Paragraph>{quote.manufacturingTime} days</Paragraph>
        </Box>
      </Box>
    </Box>
  );
});
